import { render, staticRenderFns } from "./GridCard.vue?vue&type=template&id=283fa150&scoped=true&"
import script from "./GridCard.vue?vue&type=script&lang=js&"
export * from "./GridCard.vue?vue&type=script&lang=js&"
import style0 from "./GridCard.vue?vue&type=style&index=0&id=283fa150&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283fa150",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiLazyImg: require('/app/components/UI/UiLazyImg.vue').default})
